import { getDownloadURL, uploadBytesResumable } from "firebase/storage";

export default async function uploadFile(ref, file) {    
    const metadata = {
        contentType: file.type
    };

    try {
        await uploadBytesResumable(ref, file, metadata);
        const url = await getDownloadURL(ref);
        return url;
    } catch (error) {
        console.error("Error uploading file:", error);
        return null;
    }
}